import React, { useState } from "react";
import GlobalStyles, { CommonClasses } from "../../global/GlobalStyle";
import { MdNumbers } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const VerifyEmail = () => {
  const OtpIcon = MdNumbers as React.FC<React.SVGProps<SVGSVGElement>>;
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const { verifyEmail, user, resendVerification } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    const success = await verifyEmail(otp);
    setIsLoading(false);

    if (success) {
      navigate("/dashboard");
    }
  };

  const handleResendOTP = async () => {
    setIsResending(true);
    await resendVerification(); // Use the actual function
    setIsResending(false);
  };

  return (
    <div className={GlobalStyles.containerCenter}>
      <div className={GlobalStyles.formContainer}>
        <div className={GlobalStyles.formHeader}>
          <h2 className={GlobalStyles.formHeaderTitle}>Verify Your Email</h2>
          <p className={GlobalStyles.formHeaderSubtitle}>
            We've sent a 6-digit verification code to {user?.email}
          </p>
        </div>

        <form className="p-5" onSubmit={handleSubmit}>
          <div className={GlobalStyles.formGroup}>
            <label htmlFor="otp" className={GlobalStyles.label}>
              Verification Code
            </label>
            <div className={GlobalStyles.inputWrapper}>
              <OtpIcon className={GlobalStyles.inputIcon} />
              <input
                id="otp"
                type="text"
                placeholder="Enter 6-digit code"
                className={GlobalStyles.input}
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                maxLength={6}
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading || otp.length !== 6}
            className={`${GlobalStyles.buttonPrimary} !w-full mt-5 ${
              isLoading || otp.length !== 6
                ? "opacity-50 cursor-not-allowed"
                : ""
            }`}
          >
            {isLoading ? "Verifying..." : "Verify Email"}
          </button>

          <div className="text-center mt-4">
            <button
              type="button"
              onClick={handleResendOTP}
              disabled={isResending}
              className={`${GlobalStyles.linkAccent} ${
                isResending ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {isResending ? "Resending..." : "Resend Code"}
            </button>
          </div>

          <div
            className={`mt-6 text-center ${CommonClasses.textXs} ${CommonClasses.textGray}`}
          >
            <Link to="/dashboard" className={GlobalStyles.linkAccent}>
              Skip for now
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VerifyEmail;
